<template>
  <div class="apsa-educate-search subdued pa-6">
    <img
      class="apsa-educate-search__logo mb-1"
      :src="images.apsaEducateLogo"
      alt=""
    />
    <div class="apsa-educate-search__text">
      APSA Educate is an online library for political science teaching and
      learning materials. All materials are open resources and available without
      charge.
    </div>
    <MultiLineButton class="mt-4" @click="onClick">
      Show results on APSA Educate
      <span class="d-sr-only">[opens in a new tab]</span>
    </MultiLineButton>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MultiLineButton from "~/components/page/components/buttons/MultiLineButton.vue";

export default {
  components: { MultiLineButton },
  props: {
    searchText: { type: String, default: "" },
  },
  computed: {
    ...mapState({
      images: (state) => state.theme.images,
    }),
    apsaEducateLink() {
      return `https://educate.apsanet.org/search?_sf_s=${this.searchText}`;
    },
  },
  methods: {
    onClick() {
      window.open(this.apsaEducateLink, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.apsa-educate-search {
  &__text {
    font-size: 14px;
  }
  &__logo {
    height: 22px;
    width: 126px;
    object-fit: contain;
  }
}
</style>
